const GenericStatusEnum = {
  NOT_ATTENDED: 1,
  PARTIALLY_ATTENDED: 2,
  FULLY_ATTENDED: 3,
  CANCELED: 4,
};

const GenericStatusEnumById = {
  [GenericStatusEnum.NOT_ATTENDED]: "NÃO ATENDIDO",
  [GenericStatusEnum.PARTIALLY_ATTENDED]: "PARCIALMENTE ATENDIDA",
  [GenericStatusEnum.FULLY_ATTENDED]: "TOTALMENTE ATENDIDA",
  [GenericStatusEnum.CANCELED]: "CANCELADO",
};

const GenericStatusEnumByName = {
  "NÃO ATENDIDO": GenericStatusEnum.NOT_ATTENDED,
  "PARCIALMENTE ATENDIDA": GenericStatusEnum.PARTIALLY_ATTENDED,
  "TOTALMENTE ATENDIDA": GenericStatusEnum.FULLY_ATTENDED,
  CANCELADO: GenericStatusEnum.CANCELED,
};

export { GenericStatusEnum, GenericStatusEnumById, GenericStatusEnumByName };
